// src/pages/mairie/StatistiquesCollecteurs.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { config } from '../../config';

export default function StatistiquesCollecteurs() {
    const [stats, setStats] = useState([]);
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
    const [totaux, setTotaux] = useState({
        total_general: 0,
        total_commission_general: 0
    });
    const [loading, setLoading] = useState(false);

    const fetchStats = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${config.apiBase}/mairie/stats_collecteurs.php?date=${date}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) {
                setStats(data.stats);
                setTotaux({
                    total_general: data.total_general,
                    total_commission_general: data.total_commission_general
                });
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Erreur de chargement');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
    }, [date]);

    return (
        <div className="max-w-6xl mx-auto p-6">
            <h1 className="text-2xl font-bold mb-6">📊 Performance des collecteurs</h1>

            <div className="flex items-center gap-4 mb-6">
                <label className="font-medium">Date:</label>
                <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
                />
                <button
                    onClick={fetchStats}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                    🔄 Actualiser
                </button>
            </div>

            {loading ? (
                <div className="flex items-center justify-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200 border-t-blue-600"></div>
                </div>
            ) : stats.length === 0 ? (
                <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                    <p className="text-gray-500">Aucune donnée pour cette date</p>
                </div>
            ) : (
                <>
                    <div className="overflow-x-auto">
                        <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
                            <thead className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                                <tr>
                                    <th className="px-4 py-3 text-left">Collecteur</th>
                                    <th className="px-4 py-3 text-right">Total Journalier</th>
                                    <th className="px-4 py-3 text-right">Commission 10%</th>
                                    <th className="px-4 py-3 text-right">Total Taxe</th>
                                    <th className="px-4 py-3 text-right">Commission 10%</th>
                                    <th className="px-4 py-3 text-right">Commission Totale</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {stats.map((s, index) => (
                                    <tr key={index} className="hover:bg-gray-50 transition">
                                        <td className="px-4 py-3 font-medium">{s.prenom} {s.nom}</td>
                                        <td className="px-4 py-3 text-right">{s.total_journalier.toLocaleString()} F</td>
                                        <td className="px-4 py-3 text-right text-green-600 font-semibold">{s.commission_journalier.toLocaleString()} F</td>
                                        <td className="px-4 py-3 text-right">{s.total_taxe.toLocaleString()} F</td>
                                        <td className="px-4 py-3 text-right text-green-600 font-semibold">{s.commission_taxe.toLocaleString()} F</td>
                                        <td className="px-4 py-3 text-right text-blue-600 font-bold">{s.commission_totale.toLocaleString()} F</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className="bg-gray-100 font-bold">
                                <tr>
                                    <td className="px-4 py-3">TOTAL</td>
                                    <td className="px-4 py-3 text-right">-</td>
                                    <td className="px-4 py-3 text-right">-</td>
                                    <td className="px-4 py-3 text-right">-</td>
                                    <td className="px-4 py-3 text-right">-</td>
                                    <td className="px-4 py-3 text-right text-blue-700 text-lg">
                                        {totaux.total_commission_general.toLocaleString()} F
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div className="mt-4 text-sm text-gray-500 text-right">
                        Total collecte: {totaux.total_general.toLocaleString()} F
                    </div>
                </>
            )}
        </div>
    );
}